import React from 'react'
import {
  SearchableItem,
  SearchableGroup,
  SearchableTopicModelAsMember,
  MatchedSearchIndexes
} from './SelectEntitiesForm.types'
import IconLayers from 'front-end/src/components/common/icon/IconLayers'
import IconUser from 'front-end/src/components/common/icon/IconUser'
import { Flex } from 'front-end/src/components'
import { Trans } from '@lingui/macro'
import { HighlightMatchedString } from './HighlightMatchedString'
import { EventModelAsStudent } from 'front-end/src/graphql/private/PrivateSchemaTypes'

type ItemDecorationComponentProps = {
  item: SearchableItem
  matches: MatchedSearchIndexes[]
}

export const ItemDecorationComponent: React.FC<ItemDecorationComponentProps> =
  ({ item, matches }) => {
    if (item.type === 'GroupModelGQLBase') {
      return (
        <Flex align="center">
          <IconUser mr="4px" />
          <Trans>{(item.original as SearchableGroup).usersCount} members</Trans>
        </Flex>
      )
    }

    if (item.type === 'EventModelAsStudent') {
      return (
        <Flex>
          {(item.original as unknown as EventModelAsStudent).formattedTimeRange}
        </Flex>
      )
    }

    if (item.type === 'TopicModelAsMember') {
      return (
        <Flex align="center">
          <IconLayers mr="4px" />
          <HighlightMatchedString
            text={
              (item.original as SearchableTopicModelAsMember).workspace.name
            }
            matches={matches}
          />
        </Flex>
      )
    }

    return null
  }
